import { render } from "./HomeBestOffers.vue?vue&type=template&id=6ee8ea19"
import script from "./HomeBestOffers.vue?vue&type=script&lang=js"
export * from "./HomeBestOffers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__